import moment from 'moment'
import { mapActions, mapState } from 'vuex'

import { getMasterDataText } from '../helpers'

export default {
  data() {
    return {
      MODAL_FORM_LOG: 'MODAL_FORM_LOG',
      isSubmittedFormLog: false,
      initialValueLog: {
        logId: null,
        topic: null,
        description: null,
        schedule_date: null,
      },
    }
  },

  computed: {
    ...mapState('document', {
      logs: 'logs',
    }),
    mapLogs() {
      return this.logs.map((log) => {
        return {
          ...log,
          _topic: getMasterDataText(log.topic, this.$t),
        }
      })
    },
  },

  async mounted() {
    await this.fetchLogList()
  },

  methods: {
    ...mapActions('document', {
      getLogList: 'getLogList',
      createLog: 'createLog',
      updateLog: 'updateLog',
      updateLogStatus: 'updateLogStatus',
      deleteLog: 'deleteLog',
    }),
    fetchLogList() {
      return this.getLogList({
        ref_doc: this.refDoc,
        ref_id: this.refId,
      })
    },
    handleClickCreateLog() {
      $(`#${this.MODAL_FORM_LOG}`).modal('show')
    },
    async handleSubmitFormLog(form, callback) {
      this.isSubmittedFormLog = true
      let response
      if (form.logId) {
        response = await this.updateLog({
          id: form.logId,
          data: {
            'description': form.description,
            'schedule_date': form.schedule_date,
          },
        })
        this.notify(this.$vs, {
          text: this.$t('message.editlogsuccess'),
          color: 'success',
          icon: 'cloud',
        })
      } else {
        response = await this.createLog({
          'topic': form.topic,
          'description': form.description,
          'schedule_date': form.schedule_date,
          'ref_doc': this.refDoc,
          'ref_id': this.refId,
        })
        this.notify(this.$vs, {
          text: this.$t('message.createlogsuccess'),
          color: 'success',
          icon: 'cloud',
        })
      }
      if (response.success) {
        await this.fetchLogList()

        callback()
        this.isSubmittedFormLog = false
        $(`#${this.MODAL_FORM_LOG}`).modal('hide')
      }
    },
    async handleClickToggleStatusLog(index, log) {
      const response = await this.updateLogStatus({
        id: log._id,
        data: {
          status: log.status === 'done' ? 'todo' : 'done',
        },
      })
      await this.fetchLogList()
      this.notify(this.$vs, {
        text: this.$t('message.updatelogstatussuccess'),
        color: 'success',
        icon: 'cloud',
      })
    },
    handleClickEditLog(index, log) {
      this.initialValueLog.logId = log._id,
      this.initialValueLog.topic = log.topic
      this.initialValueLog.description = log.description
      this.initialValueLog.schedule_date = log.schedule_date ? moment(log.schedule_date).toDate() : null
      $(`#${this.MODAL_FORM_LOG}`).modal('show')
    },
    handleClickDeleteLog(index, log) {
      this.modalConfirmDelete.show = true
      this.confirmDeleteType = 'log'
      this.confirmDeleteLogId = log._id
    },
    async onDeleteLog(logId) {
      this.modalConfirmDelete.loading = true
      const response = await this.deleteLog(logId)
      if (response.success) {
        await this.fetchLogList()

        this.modalConfirmDelete.loading = false
        this.modalConfirmDelete.show = false
        this.notify(this.$vs, {
          text: this.$t('message.deletelogsuccess'),
          color: 'danger',
          icon: 'delete',
        })
      }
    },
  },
}



// WEBPACK FOOTER //
// ./src/mixins/docRefLog.js